import React, { Component } from 'react'
import injectStyles from 'react-jss'
import classNames from 'classnames'
import { ControlWrapperExtended as ControlWrapper } from './../ControlWrapper/ControlWrapper'
import CrossIcon from '../ListControl/CrossIconSvg'
import BinIcon from './BinIconSvg'

const styles = {
  input: {
    height: 40,
    paddingLeft: 22,
    paddingRight: 22,
    borderRadius: 2,
    border: '1px solid #dee1e5',
    backgroundColor: 'white',
    width: 338,
    boxSizing: 'border-box',
    color: '#858585',
    appearance: 'none',
    marginBottom: 16,
    '&:last-child': {
      marginBottom: 0,
    },
  },
  addIconContainer: {
    textAlign: 'right',
  },
  addIcon: {
    opacity: 0.5,
    transition: 'opacity 0.3s',
    cursor: 'pointer',
    '&:hover': {
      opacity: 1,
    },
  },
  binIcon: {
    position: 'absolute',
    top: 10,
    right: 0,
    opacity: 0.5,
    transition: 'opacity 0.3s',
    cursor: 'pointer',
    '&:hover': {
      opacity: 1,
    },
  },
  row: {
    position: 'relative',
  },
  circleIcon: {
    width: 8,
    height: 8,
    backgroundColor: '#4F4F4F',
    borderRadius: '50%',
  },
}

class ListControl extends Component {

  state = {
    value: this.props.placeholder,
    values: normalizeValuesObject(this.props.values),
  }

  updatePlaceholder = (e) => {
    const { onUpdate } = this.props
    var value = e.target.value
    onUpdate({
      placeholder: value,
    })
  }

  onChange = (e) => this.setState({ value: e.target.value });

  onAddListItem = () => {
    const { onUpdate } = this.props
    const { values } = this.state
    var newValues = Object.assign({}, values)
    newValues[''] = ''
    onUpdate({ values: newValues })
    this.setState({
      values: newValues,
    }, () => {
      var lastInput = this.inputRefs_[this.inputRefs_.length - 1]
      lastInput.focus()
    })
  }

  onDeleteListItem = (key) => {
    const { values } = this.state
    var newValues = Object.assign({}, values)
    delete newValues[key]
    var keysSameAsValues = Object.entries(newValues)
      .every(([ oKey, oValue ]) =>  oKey === oValue)
    this.props.onUpdate({ values: keysSameAsValues ? Object.keys(newValues) : newValues })
    this.setState({values: newValues})
  };

  updateValue = (key, value) => {
    const { values } = this.state
    var newValues = Object.assign({}, values)
    newValues[key] = value
    this.setState({ values: newValues })
  }

  saveListItem = (key, cb) => {
    const { values } = this.state
    // We also need to rename the key to the value but preserve its position
    // in the list of keys
    var newValues = {}, keysSameAsValues = true
    Object.entries(values).forEach(([ oKey, oValue ]) => {
      if (oKey == key){
        newValues[oValue] = oValue
      } else {
        newValues[oKey] = oValue
        if (oKey !== oValue)
          keysSameAsValues = false
      }
    })
    this.props.onUpdate({ values: keysSameAsValues ? Object.keys(newValues) : newValues })
    this.setState({ values: newValues }, cb)
  }

  onKeyUp = (e) => {
    if (e.keyCode == 13){
      this.saveListItem('', () => this.onAddListItem())
    }
  }

  render = () => {
    var {
      placeholder,
      classes,
      disabled,
      type,
      style,
      icon,
      ...otherProps } = this.props
    const { value, values } = this.state

    this.inputRefs_ = []

    return <ControlWrapper
      {...otherProps}
      icon={icon || <div className={classes.circleIcon} />}
    >
      {Object.entries(values).map(([key, value]) => {
        return <div className={classes.row} key={key}>
          <input
            className={classes.input}
            value={value}
            ref={el => el ? this.inputRefs_.push(el) : null}
            onChange={e => this.updateValue(key, e.target.value)}
            onBlur={e => this.saveListItem(key)}
            onKeyUp={this.onKeyUp}
          />
          <BinIcon
            className={classes.binIcon}
            onClick={() => this.onDeleteListItem(key)}
          />
        </div>
      })}
      <div className={classes.addIconContainer}>
        <CrossIcon
          className={classes.addIcon}
          onClick={this.onAddListItem}
        />
      </div>
    </ControlWrapper>
  }
}

export default injectStyles(styles)(ListControl)

/**
 * If the values parameter is an array this will convert it to an object with
 * the same keys and values
 * @param {Array|object} values
 * @returns {object}
 */
function normalizeValuesObject(values){
  if (typeof values !== 'object')
    return {}
  if (!(values instanceof Array))
    return values
  var newValuesObj = {}
  values.forEach(val => newValuesObj[val] = val)
  return newValuesObj
}


// WEBPACK FOOTER //
// ./src/modules/ListControl/ListControl.js